export const paymentTags = [
  'payments_AddApprove',
  'master_bank-accounts',
] as const;
